export default __webpack_public_path__ + "static/media/rightImage.654245d4.png";